"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OneConfigProvider = void 0;
exports.useConfigByKey = useConfigByKey;
exports.useOneConfig = useOneConfig;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _useContext = _interopRequireDefault(require("./useContext"));

var _useAsync = require("./useAsync");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function warn(oneConfig, name) {
  if (!oneConfig) {
    // eslint-disable-next-line no-console
    throw new Error("".concat(name, " must be used inside a OneConfigProvider."));
  }
}

function useConfigByKey(key, immediate) {
  var _Context$useContainer = _useContext["default"].useContainer(useConfigByKey.name),
      oneConfig = _Context$useContainer.oneConfig,
      options = _Context$useContainer.options,
      set = _Context$useContainer.set,
      get = _Context$useContainer.get;

  warn(oneConfig, useConfigByKey.name); // 有缓存直接就执行

  var immediateValue = get(key) ? true : typeof immediate === 'boolean' ? immediate : !!options.immediate;
  var state = (0, _useAsync.useAsync)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var value;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            value = get(key);

            if (!value) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", value);

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return oneConfig === null || oneConfig === void 0 ? void 0 : oneConfig.get(key);

          case 6:
            value = _context.sent;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            set(key, value);
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", undefined);

          case 13:
            return _context.abrupt("return", value);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  })), immediateValue);
  return _objectSpread({}, state);
}

function useOneConfig() {
  var _Context$useContainer2 = _useContext["default"].useContainer(useOneConfig.name),
      oneConfig = _Context$useContainer2.oneConfig;

  warn(oneConfig, useOneConfig.name);
  return {
    oneConfig: oneConfig
  };
}

var OneConfigProvider = function OneConfigProvider(_ref2) {
  var value = _ref2.value,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_useContext["default"].Provider, {
    initialState: value
  }, children);
};

exports.OneConfigProvider = OneConfigProvider;